import { ASComponentSize, ASIconButton, BackArrowIcon, ComponentSize } from '@eleventheye/asui';
import { useAppSelector } from 'app/hooks';
import { getShowBackButton } from 'app/slices/AppUiSlice';
import useViewportDimensions from 'hooks/useViewportDimensions';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'routes/Routes';
import styles from './GameLogo.module.scss';

type GameLogoProps = {
  className?: string;
  onManagerClick?: () => void;
  logoUrl?: string;
};

const GameLogo: React.FC<GameLogoProps> = ({
  className = '',
  logoUrl = 'football-analytics-logo',
  onManagerClick = () => undefined,
}) => {
  const baseCls = `${styles.GameLogoTitle} ${className}`;
  return (
    <div className={baseCls} onClick={onManagerClick}>
      <img
        src={`/images/nfl/logos/app/${logoUrl}.webp`.toLowerCase()}
        alt="Football Logo"
        className={styles.GameLogo}
      />
      <span>STATS Manager</span>
    </div>
  );
};

const HeaderLogo: React.FC<GameLogoProps> = ({ className = '', onManagerClick = () => undefined, logoUrl }) => {
  const baseCls = `${styles.GameLogoContainer} ${className}`;
  return (
    <div className={baseCls}>
      <LogoWithBackButton onManagerClick={onManagerClick} logoUrl={logoUrl} />
      <span className={styles.GameLogoTitle}>STATS Manager</span>
    </div>
  );
};

const HelmetLogo: React.FC<GameLogoProps> = ({ className = '', logoUrl = 'football-analytics-logo-v3' }) => {
  const baseCls = `${styles.GameLogoTitle} ${className}`;
  return (
    <div className={baseCls}>
      <img
        src={`/images/nfl/logos/app/${logoUrl}.webp`.toLowerCase()}
        alt="Football Logo"
        className={styles.GameHelmetLogo}
      />
    </div>
  );
};

const LogoWithBackButton: React.FC<GameLogoProps> = ({ className = '', logoUrl = 'football-analytics-logo-v3' }) => {
  const baseCls = `${styles.Flip} ${styles.GameLogoContainer} ${className}`;
  const navigate = useNavigate();

  const [flippedCls, setFlipCls] = useState<string>('');
  const [iconSize, setIconSize] = useState<ASComponentSize>(ComponentSize.Large);
  const showBackButton = useAppSelector(getShowBackButton);
  const { isAppMobile } = useViewportDimensions();

  const flipCards = () => navigate(AppRoutes.WeeklyGames);

  useEffect(() => {
    setFlipCls(showBackButton ? styles.IsFlipped : '');
  }, [showBackButton]);

  useEffect(() => {
    setIconSize(isAppMobile ? ComponentSize.Small : ComponentSize.Large);
  }, [isAppMobile]);

  return (
    <div className={`${baseCls} ${flippedCls}`}>
      <div className={styles.FlipInner}>
        <div className={styles.FlipFront}>
          <img
            src={`/images/nfl/logos/app/${logoUrl}.webp`.toLowerCase()}
            alt="Football Logo"
            className={styles.FlipLogo}
          />
        </div>
        <div className={styles.FlipBack}>
          <ASIconButton icon={BackArrowIcon} size={iconSize} iconSize={24} onIconButtonTap={flipCards} />
        </div>
      </div>
    </div>
  );
};

export { GameLogo as default, LogoWithBackButton as FlipLogo, HeaderLogo, HelmetLogo };
